import React from 'react';
import { layout, spacing } from '../../styles/tokens';

export function PageContainer({ children, style }) {
  return (
    <div style={{ margin: '0 auto', maxWidth: layout.pageMaxWidth, padding: spacing.md, ...style }}>
      {children}
    </div>
  );
}

export function Section({ children, style }) {
  return <section style={{ marginBottom: spacing.lg, ...style }}>{children}</section>;
}

export function Panel({ children, style, title, actions }) {
  return (
    <div style={{ background: '#fff', border: '1px solid #e1e4e8', borderRadius: 8, padding: spacing.md, ...style }}>
      {(title || actions) && (
        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: spacing.sm }}>
          {title && <h3 style={{ margin: 0, fontSize: 18 }}>{title}</h3>}
          {actions}
        </div>
      )}
      {children}
    </div>
  );
}
